import LocationContainer from 'locations/containers/LocationsContainer';
import LocationOffline from 'locations/containers/LocationOffline';

import {
  LOCATION_BASE,
  LOCATION_DETAIL,
  LOCATION_OFFLINE
} from 'locations/constants/paths';
import LocationOfflinePageLayout from 'locations/layouts/LocationOfflinePageLayout';
import LocationListOuterLayout from 'locations/layouts/LocationListOuterLayout';
import { generatePath } from 'utils/generatePath';
import { MENU } from 'menus/constants/entities';

const routes = [
  {
    path: LOCATION_BASE,
    exact: true,
    Component: LocationContainer,
    Layout: LocationListOuterLayout
  },
  {
    path: LOCATION_OFFLINE,
    exact: true,
    Component: LocationOffline,
    Layout: LocationOfflinePageLayout
  },
  {
    path: LOCATION_DETAIL,
    exact: true,
    redirect: ({ slug }) => generatePath(MENU, 'menu', { slug })
  }
];

export default routes;
